function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import useStyle from "./Col.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
var Col = function(_param) {
    var zIndex = _param.zIndex, _width = _param.width, width = _width === void 0 ? 1 : _width, _minWidth = _param.minWidth, minWidth = _minWidth === void 0 ? 0 : _minWidth, _offset = _param.offset, offset = _offset === void 0 ? 0 : _offset, _offsetEnd = _param.offsetEnd, offsetEnd = _offsetEnd === void 0 ? 0 : _offsetEnd, padding = _param.padding, flex = _param.flex, isRtl = _param.isRtl, _s = _param.s, s = _s === void 0 ? {} : _s, _m = _param.m, m = _m === void 0 ? {} : _m, _l = _param.l, l = _l === void 0 ? {} : _l, _xl = _param.xl, xl = _xl === void 0 ? {} : _xl, testID = _param.testID, children = _param.children, rest = _objectWithoutProperties(_param, [
        "zIndex",
        "width",
        "minWidth",
        "offset",
        "offsetEnd",
        "padding",
        "flex",
        "isRtl",
        "s",
        "m",
        "l",
        "xl",
        "testID",
        "children"
    ]);
    var styles = useStyle({
        zIndex: zIndex,
        componentDefaults: {
            width: width,
            minWidth: minWidth,
            offset: offset,
            offsetEnd: offsetEnd,
            padding: padding,
            flex: flex
        },
        s: s,
        m: m,
        l: l,
        xl: xl,
        isRtl: isRtl
    });
    return _jsx("div", _objectSpread({}, rest, injectTestId(testID), {
        css: styles,
        "data-layout": "col",
        children: children
    }));
};
export { Col };
export default Col;
